$(() => {
  $('.news-media-block .news-list .news-item').each(function () {
    const $t = $(this);
    const newsContent = $t.html();
    let newsText = $('<div></div>').html(newsContent).text();
    newsText = $.trim(newsText);
    newsText = newsText.split('\n').map($.trim).filter(Boolean).join(' ');
    $t.append(`<span>${newsText}</span>`)
  });
});
